import { z } from 'zod'

export const urlFiltersSchema = z.record(z.string(), z.string())
